export const mutations = {
    SET_USERS(state: any, users: any) {
        state.users = users;
    },
    SET_LOGINS(state: any, logins: any) {
        state.logins = logins;
    },
    REMOVE_LOGIN(state: any, id: string) {
        state.logins = state.logins.filter((l: any) => l.id !== id);
    },
    SET_MODELS(state: any, models: any) {
        state.models = models;
    },
    SET_SELECTEDUSER(state: any, selectedUser: any) {
        state.selectedUser = selectedUser;
    },
    SET_SELECTEDMODEL(state: any, selectedModel: any) {
        state.selectedModel = selectedModel;
    },
    SET_SELECTEDSCENARIO(state: any, selectedScenario: any) {
        state.selectedScenario = selectedScenario;
    },
    SET_LOGINEDITING(state: any, loginEditing: any) {
        state.loginEditing = loginEditing;
    },
    SET_SCENARIOSTATUS(state: any, scenarioStatus: any) {
        state.scenarioStatus = scenarioStatus;
    },
    SET_GROUPS(state: any, groups: any) {
        state.groups = groups;
    },
    SET_SELECTEDGROUP(state: any, selectedGroup: any) {
        state.selectedGroup = selectedGroup;
    },
    SET_GROUPUSERS(state: any, groupUsers: any) {
        state.groupUsers = groupUsers;
    },
    SET_MODELGROUPS(state: any, modelGroups: any) {
        state.modelGroups = modelGroups;
    },
    SET_MODELROLES(state: any, modelRoles: any) {
        state.modelRoles = modelRoles;
    },
    SET_GLOBALROLES(state: any, globalRoles: any) {
        state.globalRoles = globalRoles;
    },
    SET_SELECTEDROLE(state: any, selectedRole: any) {
        state.selectedRole = selectedRole;
    },
    SET_ROLEGROUPS(state: any, roleGroups: any) {
        state.roleGroups = roleGroups;
    },
    SET_ISADDINGGROUP(state: any, value: boolean) {
        state.isAddingGroup = value;
    },
    SET_ISADDINGLOGIN(state: any, value: boolean) {
        state.isAddingLogin = value;
    },
};
